import { createContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const FormContext = createContext({});

export const FormProvider = ({ children }) => {
    let location = useLocation()
    const [studentEdit, setStudentEdit] = useState({})

    useEffect(() => {
        if (location.pathname !== '/enrollments/store') setStudentEdit({})

    }, [location.pathname]);

    return (
        <FormContext.Provider
            value={{ studentEdit, setStudentEdit }}
        >
            {children}
        </FormContext.Provider>
    );
};
